import { __awaiter, __generator } from "tslib";
import { fetchSFCCSetting } from "../site-settings/fetch-sfcc-setting";
import { getSFCCProductSearchRequestHeaders } from "../../sfcc/utilities/get-sfcc-product-search-request-headers";
import { getSFCCRequestHeaders } from "../../sfcc/utilities/get-sfcc-request-headers";
import { fetchGet } from "../../common";
export var fetchSfccSearchResults = function (query) { return __awaiter(void 0, void 0, void 0, function () {
    var sfccProductSearchApiBaseUrl, url, requestInit;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, getSfccProductSearchBaseUrl()];
            case 1:
                sfccProductSearchApiBaseUrl = _a.sent();
                if (!sfccProductSearchApiBaseUrl) {
                    console.warn("SFCC product search base URL not set");
                    return [2 /*return*/, null];
                }
                url = sfccProductSearchApiBaseUrl + "/product_search?" + query;
                return [4 /*yield*/, getSFCCRequestHeaders()];
            case 2:
                requestInit = _a.sent();
                return [2 /*return*/, fetchGet(url, requestInit)];
        }
    });
}); };
export var fetchSfccProductDetails = function (productIds) { return __awaiter(void 0, void 0, void 0, function () {
    var sfccProductSearchApiBaseUrl, url, sfccheaders;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, getSfccProductSearchBaseUrl()];
            case 1:
                sfccProductSearchApiBaseUrl = _a.sent();
                if (!sfccProductSearchApiBaseUrl) {
                    console.warn("SFCC product search base URL not set");
                    return [2 /*return*/, null];
                }
                url = sfccProductSearchApiBaseUrl + "/products/(" + productIds.join(',') + ")?expand=images,prices&c_method=getPrices";
                return [4 /*yield*/, getSFCCProductSearchRequestHeaders()];
            case 2:
                sfccheaders = _a.sent();
                return [2 /*return*/, fetchGet(url, sfccheaders)];
        }
    });
}); };
export var getSfccProductSearchBaseUrl = function () { return __awaiter(void 0, void 0, void 0, function () {
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, fetchSFCCSetting()];
            case 1: return [2 /*return*/, (_a = (_b.sent())) === null || _a === void 0 ? void 0 : _a.productSearchApiUrl];
        }
    });
}); };
